module.exports = __webpack_public_path__ + "media/images/bg-pattern-whatwedo-781d25180573e47bd6d9362fda775aee.png";